import { useCallback } from 'react';
import { activeUsersAndTeamsFromIndexedB } from 'queries/members';
import { fullName } from 'utils/full-name';
import { useGetUserFromIndexedDb } from './use-idb';

export const useUserNameGetter = (): ((id: number) => string) => {
  const { users = [] } = activeUsersAndTeamsFromIndexedB.getActiveUsersAndTeams;

  return useCallback(
    (id) => {
      const user = users.find((u) => u.userId === id);

      const userName = user && fullName(user);

      return userName || '';
    },
    [users],
  );
};

export const useUserName = (id: number): string => {
  const user = useGetUserFromIndexedDb(id);
  const name = user ? fullName(user) : '';

  return name || user?.emailId || '';
};
